document.addEventListener('DOMContentLoaded', () => {
  const drawerContainer = document.getElementById('Details-menu-drawer-container')
  if (!drawerContainer) return

  const rootUrl =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/'

  const addUrl = `${rootUrl}cart/add.js`
  const cartUrl = `${rootUrl}cart.js`
  const sectionsUrl = `${rootUrl}${rootUrl.endsWith('/') ? '' : '/'}?sections=cart-drawer,cart-icon-bubble`

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

  const replaceFromHTML = (html, selector) => {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    const newEl = doc.querySelector(selector)
    const currentEl = document.querySelector(selector)
    if (newEl && currentEl) currentEl.replaceWith(newEl)
  }

  const renderSections = (sections) => {
    if (sections['cart-icon-bubble']) {
      replaceFromHTML(sections['cart-icon-bubble'], '#cart-icon-bubble')
    }

    if (sections['cart-drawer']) {
      replaceFromHTML(sections['cart-drawer'], 'cart-drawer')
    }
  }

  const updateBubbleCountFallback = async () => {
    try {
      const res = await fetch(cartUrl, {
        headers: { Accept: 'application/json' }
      })

      if (!res.ok) return

      const cart = await res.json()
      const bubble = document.querySelector('#cart-icon-bubble')
      if (!bubble) return

      const countTarget =
        bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]') ||
        bubble.querySelector('.cart-count-bubble span') ||
        bubble.querySelector('.cart-count-bubble')

      if (!countTarget) return

      const count = cart.item_count || 0

      if (count > 0) {
        countTarget.textContent = count
        const bubbleWrap = bubble.querySelector('.cart-count-bubble')
        if (bubbleWrap) bubbleWrap.classList.remove('hidden')
      }
    } catch (_) {}
  }

  const openCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer')
    if (!drawer) return

    if (typeof drawer.open === 'function') {
      drawer.open()
      return
    }

    drawer.classList.add('active')
  }

  const closeMenuDrawer = () => {
    const summary = drawerContainer.querySelector('summary')
    if (summary && drawerContainer.hasAttribute('open')) {
      summary.click()
    }
  }

  const publishCartUpdate = (cartData) => {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart: cartData }
      })
    )

    if (window.PUB_SUB_EVENTS && window.publish && window.PUB_SUB_EVENTS.cartUpdate) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'ir-header-bundle-atc',
        cartData
      })
    }
  }

  drawerContainer.addEventListener(
    'submit',
    async (e) => {
      const form = e.target.closest('.menu-drawer__bundle-form[data-type="add-to-cart-form"]')
      if (!form) return

      e.preventDefault()

      const button = form.querySelector('.menu-drawer__bundle-atc')
      const spinner = button ? button.querySelector('.loading__spinner') : null
      const productForm = form.closest('.product-form')
      const errorWrapper = productForm ? productForm.querySelector('.product-form__error-message-wrapper') : null
      const errorMessage = productForm ? productForm.querySelector('.product-form__error-message') : null

      if (errorWrapper) errorWrapper.hidden = true
      if (errorMessage) errorMessage.textContent = ''

      if (button) {
        if (spinner) spinner.classList.remove('hidden')
        button.classList.remove('is-success')
        button.classList.add('is-loading')
        button.setAttribute('aria-disabled', 'true')
        button.disabled = true
      }

      const startedAt = Date.now()
      const minimumLoadingTime = 700

      try {
        const addRes = await fetch(addUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: new FormData(form)
        })

        const addData = await addRes.json()

        if (!addRes.ok || addData.status) {
          throw new Error(addData.description || addData.message || 'Failed to add item to cart')
        }

        const elapsed = Date.now() - startedAt
        if (elapsed < minimumLoadingTime) {
          await wait(minimumLoadingTime - elapsed)
        }

        const secRes = await fetch(sectionsUrl, {
          headers: { Accept: 'application/json' }
        })

        if (secRes.ok) {
          const sections = await secRes.json()
          renderSections(sections)
        }

        await updateBubbleCountFallback()
        publishCartUpdate(addData)

        if (button) {
          button.classList.remove('is-loading')
          button.classList.add('is-success')
          if (spinner) spinner.classList.add('hidden')
        }

        await wait(350)

        closeMenuDrawer()

        setTimeout(() => {
          openCartDrawer()
        }, 220)

        if (button) {
          setTimeout(() => {
            button.classList.remove('is-success')
            button.removeAttribute('aria-disabled')
            button.disabled = false
          }, 900)
        }
      } catch (error) {
        if (errorWrapper) errorWrapper.hidden = false
        if (errorMessage) errorMessage.textContent = error.message || 'Something went wrong'

        if (button) {
          button.classList.remove('is-loading')
          button.removeAttribute('aria-disabled')
          button.disabled = false
          if (spinner) spinner.classList.add('hidden')
        }
      }
    },
    true
  )
})